import { Injectable, OnInit, Injector } from '@angular/core';
import { $WebSocket } from 'angular2-websocket/angular2-websocket';
import { environment } from '../../../../environments/environment';


//declare var SockJS
declare var $;
export interface OnWSConnection{
    onConnected();
    onDisconnected();
}
export abstract class ParserService implements OnInit, OnWSConnection {
    close(p){
        this.ws.close(p);
    }
    constructor(protected ws: WsService2) {
        console.log("Will try to register parser", ws)
        ws.registerParser(this);
    }
    ngOnInit() {
        console.log("Callin ngOnInit of ParserService")
        this.ws.registerParser(this);
    }
    abstract parseMessage(m);
  
    onConnected() {
     
    }

    onDisconnected() {
    
    }
    protected send(cmd, params = {}) {
        this.ws.send(cmd, params);
    }
}
@Injectable()
export class WsService2 {
    ws: any;
    changeTitles(){
        switch (environment.lng) {
            case "de":
            $(document).prop('title', 'TutorLand');
            break;
            case "ru":
            $(document).prop('title', environment.title);
            break;
            
          }
    }
    setFromMobile(to){
        this.fromMobile = to;
    }
    fromMobile = false;
    getFromMobile(){
        return this.fromMobile;
    }
    wasConnected = false
    hbManager
    setHbManager(hbManager){
        this.hbManager = hbManager;
    }

    hasBeenConnected(){
        return this.wasConnected;
    }

    getMe(){
        return this.userHash;
    }
    userHash;
    parsers: ParserService[] = [];
    onWsConnectionParsers: OnWSConnection[] = [];
    setHash(h) {
        this.userHash = h;
    }
    registerOnWSConnection(cb: OnWSConnection){
        for (let c of this.onWsConnectionParsers){
            if (c == cb)return;
        }
        this.onWsConnectionParsers.push(cb);
    }
    registerParser(p: ParserService) {

        this.parsers.push(p);
        console.log("Registering parser", p)
    }
    init() {
        console.log("Creating ws")
        this.ws = new $WebSocket(environment.wsUrl, null, { initialTimeout: 0, maxTimeout : 300000, reconnectIfNotNormalClose :false});
        //new SockJS(environment.wsUrl);//
        console.log("Registering on open")
        this.ws.onOpen(this.onOpen.bind(this));
        this.ws.onClose(this.onClose.bind(this));
        this.ws.onMessage(this.onMessage.bind(this));
        this.ws.onError(function(e, r){
            console.log(e, r);
            
        })
    }
      disconnected=true;
    sameMediaFull = false;
    connect(force?) {
        console.log("Will try to connect")
        var url = environment.wbBackendUrl + "api/check/" + this.getMe();
    var self = this;
    self.ws.connect(force);
    /*
    $.ajax({
      url: url,
      method: "POST",
      success: function (data) {
          console.log(data)
        if (data && data.object && data.status){
           var ob = data.object;
           var startsAt = moment(ob["startsAt"], "x");
           var endsAt = moment(ob["startsAt"]+ob["duration"], "x");
           console.log("Starts at is "+startsAt.format("DD.MM.YYYY HH:mm"));
           console.log("Now is "+moment().format("DD.MM.YYYY HH:mm"));
           console.log("Starts at is "+endsAt.format("DD.MM.YYYY HH:mm"));
          // console.log("Now 15 mins before is "+startsAt.add(-15, "m").format("DD.MM.YYYY HH:mm"));
           if (moment().add(15, "m").isAfter(startsAt) && endsAt.isAfter(moment().add(15, "m"))){
                if (ob["roomFull"]){
                    window.location.href = "#/full/" + self.getMe();
                }else{
                    self.sameMediaFull = ob["sameMediaFull"];
                    self.ws.connect(force);
                }
           }else{
                window.location.href = "#/notready/"+self.getMe()+"/" + startsAt;
           }
          
        }else{
          //  window.alert("Could not get content hash, please, contact the support");
          setTimeout(function(){
            self.connect(force);
          }, 5000);
        }
      },
      error: function (error) {
        setTimeout(function(){
          self.connect(force);
        }, 5000);
       // alert("Could not connect to server, please, try again or contact the support");
      }
    })*/
        
    }
    onOpen() {
        console.log("Got onOpen event", this.parsers);
            this.disconnected = false;
            this.wasConnected = true;
        for (let p of this.parsers) {
            try {
                console.log("Calling parser ", p)
                p.onConnected();
            } catch (err) { console.error(err); }
        }
        for (let p of this.onWsConnectionParsers) {
            try {
                p.onConnected();
            } catch (err) { console.error(err); }
        }
    }
    isConnected(){
        return !this.disconnected
    }
    onClose(param) {
        console.log("WS was closed, with param ", param);
        console.log("May be here we will connect again");
        this.disconnected = true;
      //  this.cleanResources();
      console.log("Will try to connect again");
      if (!this.dontConnectAgain){
          this.connect(true);
      }
      //  this.ws.connect(true);
    }
   
    cleanResources(){
        for (let p of this.parsers) {
            try {
                p.onDisconnected();
            } catch (err) { console.error(err); }
        }
    }
    onMessage(m) {
      if (this.hbManager)
        this.hbManager.onHb();//update hb on each message


        for (let p of this.parsers) {
            try {
                p.parseMessage(JSON.parse(m.data));
            } catch (err) { console.error(err); }
        }
    }






    send(cmd, data = {}) {
        data['cmd'] = cmd;
        data['from'] = this.userHash;
        if (cmd != "setCurrentState" && cmd != 'snapshot'){
            console.log("Will send ", JSON.stringify(data))
        }
        try{this.ws.send(data).subscribe(observer => {
        //    if(cmd != 'video-snapshot')
         //   console.log("message sent", JSON.stringify(data));
        }, error=>{
            console.log("Got send error ", error);
        });}catch(errpr){
            console.log("Caught error ", errpr)
        }
    }
    dontConnectAgain=false;
    close(fromBye=false) {
        console.log("CLsoing ws");
        this.dontConnectAgain = fromBye;
        if (this.ws) {
            try {
                this.ws.close(true);
            } catch (err) {
                console.error(err);
            }
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/ws/ws.service.ts